/// <reference types="@emotion/react/types/css-prop" />
import {ModuleNode} from '@backstage-components/base';
import {css} from '@emotion/react';
import {parseJSON} from 'date-fns';
import {motion} from 'framer-motion';
import React, {FC, useState} from 'react';
import {SchemaType} from './CountdownDefinition';
import {intervalToCountdown} from './status-machine/countdown-status-machine';
import {Clock} from './subComponents/Clock';
import {Eyebrow} from './subComponents/Eyebrow';

export const CountdownPreviewComponent: FC<
  ModuleNode<'Countdown', SchemaType>
> = (definition) => {
  const {props, id, style} = definition.module;
  const {
    typography = {},
    divider,
    isUnitUnderNum = true,
    isCountdownColumn = false,
    titleText,
    unitLabels = {},
    endTime,
  } = props;

  const [now] = useState<number>(Date.now());
  const end = parseJSON(endTime);

  const remaining = intervalToCountdown({start: now, end});
  const hasDaysLeft = (remaining.days ?? 0) > 0;
  const days = remaining.days;
  const hours = remaining.hours;
  const minutes = remaining.minutes;
  const seconds = remaining.seconds;

  const styles = [
    css({
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      alignItems: 'center',
      color: typography.primaryTextColor,
      fontFamily: typography.fontFamily,
    }),
    css`
      ${style}
      ${props.styleAttr}
    `,
  ];

  return (
    <motion.div id={id} css={styles} className="countdown-wrapper">
      <Eyebrow titleText={titleText} typography={typography} />
      <Clock
        dateParts={{days, hours, minutes, seconds}}
        divider={divider}
        hasDaysLeft={hasDaysLeft}
        typography={typography}
        unitLabels={unitLabels}
        isCountdownColumn={isCountdownColumn}
        isUnitUnderNum={isUnitUnderNum}
      />
    </motion.div>
  );
};
